import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";

interface LanguageState {
  language: string;
  loading: boolean;
}

const initialState: LanguageState = {
  language: localStorage.getItem("language") || "az", 
  loading: false, 
};

export const setLanguageAsync = createAsyncThunk(
  "language/setLanguage", 
  async (lang: string) => {
    return new Promise<string>((resolve) => 
      setTimeout(() => resolve(lang), 1000) 
    );
  }
);

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
      localStorage.setItem("language", action.payload);
    },
  },
    
  extraReducers: (builder) => {
    builder
      .addCase(setLanguageAsync.pending, (state) => {
        state.loading = true; 
      })
      .addCase(setLanguageAsync.fulfilled, (state, action) => {
        state.language = action.payload; 
        state.loading = false; 
      })
      .addCase(setLanguageAsync.rejected, (state) => {
        state.loading = false; 
      });
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
